module.exports = __webpack_public_path__ + "img/pic5.f8b08066.png";